import * as types from './index';

export const getSAProfileDetailsAction = (data) => { 
    return {
    type: types.SA_PROFILE_DETAILS,
    data
    }
};

export const updateSAProfileDetailsAction = (data) => {
    return {
    type: types.SA_PROFILE_DETAILS_UPDATE, 
    data
    }
};

